"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledSortIndicator = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const core_1 = require("@veeam/core");
const sizing_1 = require("../../../../../design/constants/sizing");
const base_1 = require("../../../../../design/themes/base");
exports.StyledSortIndicator = styled_components_1.default.div `
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    color: ${base_1.baseTheme.colorControlIcon.var()};
    width: ${sizing_1.sizing.sizeSpaceL.var()};
    margin-right: calc(${sizing_1.sizing.sizeSpaceL.var()} * -1);

    ${({ direction }) => direction === core_1.SORT_DIRECTION.desc &&
    (0, styled_components_1.css) `
            transform: rotate(180deg);
        `}
`;
//# sourceMappingURL=SortIndicator.styles.js.map